(function () {
  'use strict';
  var D = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur = (window.CH && window.CH.currency) || 'EUR';
  function money(c) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur }).format(c / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* Cart drawer */
  var drawer = D.querySelector('[data-drawer]');
  var dBody = drawer && drawer.querySelector('[data-drawer-body]');
  var dFoot = drawer && drawer.querySelector('[data-drawer-foot]');
  var lastFocus = null;
  function setCount(n) {
    D.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
  }
  function render(cart) {
    setCount(cart.item_count);
    if (!dBody) return cart;
    if (!cart.items.length) {
      dBody.innerHTML = '<div class="empty"><p>Ton panier est vide.</p><a class="btn btn-ghost" href="/collections/all">Voir le catalogue</a></div>';
      dFoot.hidden = true;
      return cart;
    }
    dFoot.hidden = false;
    dBody.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img src="' + esc(sized(i.image, 160)) + '" alt="" width="72" height="72" loading="lazy">' : '<span></span>';
      var vt = i.variant_title && i.variant_title !== 'Default Title' ? '<p class="note">' + esc(i.variant_title) + '</p>' : '';
      var props = '';
      if (i.properties) Object.keys(i.properties).forEach(function (k) { var val = i.properties[k]; if (val && k.charAt(0) !== '_') props += '<span class="line-prop">' + esc(k) + ' : ' + esc(val) + '</span>'; });
      var k = esc(i.key);
      return '<div class="line">' + img + '<div><p class="line-title"><a href="' + esc(i.url) + '">' + esc(i.product_title) + '</a></p>' + vt + props +
        '<strong>' + money(i.final_line_price) + '</strong>' +
        '<div class="line-row"><div class="qty" role="group" aria-label="Quantité">' +
        '<button type="button" data-line="' + k + '" data-q="' + (i.quantity - 1) + '" aria-label="Retirer un exemplaire">−</button>' +
        '<output>' + i.quantity + '</output>' +
        '<button type="button" data-line="' + k + '" data-q="' + (i.quantity + 1) + '" aria-label="Ajouter un exemplaire">+</button></div>' +
        '<button type="button" class="link-btn" data-line="' + k + '" data-q="0">Retirer</button></div></div></div>';
    }).join('') + preNote(cart.items);
    var t = dFoot.querySelector('[data-total]'); if (t) t.textContent = money(cart.total_price);
    return cart;
  }
  function isPre(i) { return !!(i.properties && i.properties['Précommande']); }
  function preNote(items) {
    var pre = items.filter(isPre);
    if (!pre.length) return '';
    var when = pre[0].properties['Précommande'].replace(/^Expédition à partir du /, '');
    if (pre.length === items.length) return '<p class="pre-note">Précommande : ton colis partira dès la sortie, le ' + esc(when) + '.</p>';
    return '<p class="pre-note">Ton panier contient une précommande : toute la commande partira ensemble à la sortie, le ' + esc(when) + '. Pour recevoir les autres produits tout de suite, passe deux commandes.</p>';
  }
  function load() { return api('/cart.js').then(render); }
  function openDrawer() {
    if (!drawer) { window.location.href = '/cart'; return; }
    lastFocus = D.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    D.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('.drawer-head [data-drawer-close]'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    D.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function showError(scope, err) {
    var box = scope && scope.querySelector('[data-add-error]');
    var msg = (err && (err.description || err.message)) || "Ce produit n'a pas pu être ajouté. Réessaie dans un instant.";
    if (box) { box.textContent = msg; box.hidden = false; }
  }
  function add(btn, variant, qty, scope, props) {
    if (!variant || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var err = scope && scope.querySelector('[data-add-error]'); if (err) err.hidden = true;
    var item = { id: variant, quantity: qty };
    if (props && Object.keys(props).length) item.properties = props;
    api('/cart/add.js', { items: [item] })
      .then(load)
      .then(openDrawer)
      .catch(function (e) { showError(scope, e); })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }
  window.CHCart = { open: function () { load().then(openDrawer); }, close: closeDrawer, load: load };

  D.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open],[data-drawer-close],[data-line],[data-add],[data-cookie-prefs]');
    if (!t) return;
    if (t.hasAttribute('data-cart-open')) { e.preventDefault(); load().then(openDrawer).catch(function () { window.location.href = '/cart'; }); }
    else if (t.hasAttribute('data-drawer-close')) { closeDrawer(); }
    else if (t.hasAttribute('data-line')) {
      t.disabled = true;
      api('/cart/change.js', { id: t.getAttribute('data-line'), quantity: Number(t.getAttribute('data-q')) }).then(render).catch(load);
    }
    else if (t.hasAttribute('data-add')) { e.preventDefault(); var pr = t.getAttribute('data-prop'); add(t, Number(t.getAttribute('data-add')), 1, t.closest('[data-card]'), pr ? { 'Précommande': pr } : null); }
    else if (t.hasAttribute('data-cookie-prefs')) {
      if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
    }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  D.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-buy]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'); if (!btn || btn.disabled) return;
    var props = {};
    f.querySelectorAll('[name^="properties["]').forEach(function (inp) { var k = inp.name.slice(11, -1); if (k && inp.value) props[k] = inp.value; });
    add(btn, Number(f.querySelector('[name="id"]').value), Number(f.querySelector('[name="quantity"]').value) || 1, f, props);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) load(); });

  /* Quantity stepper */
  D.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input'), out = q.querySelector('output');
    q.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]'); if (!b) return;
      var v = Math.max(1, Math.min(10, (Number(input.value) || 1) + Number(b.getAttribute('data-step'))));
      input.value = v; out.textContent = v;
    });
  });

  /* Gallery */
  D.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-track]'); if (!track) return;
    var thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' }); });
    });
    var prev = g.querySelector('[data-g-prev]'), next = g.querySelector('[data-g-next]');
    function go(d) { track.scrollBy({ left: track.clientWidth * d, behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if ('IntersectionObserver' in window && thumbs.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = Array.prototype.indexOf.call(track.children, en.target);
          thumbs.forEach(function (b, j) { b.setAttribute('aria-current', String(i === j)); });
        });
      }, { root: track, threshold: 0.6 });
      Array.prototype.forEach.call(track.children, function (c) { io.observe(c); });
    }
  });

  /* Estimated delivery: 2 to 3 business days */
  D.querySelectorAll('[data-eta]').forEach(function (el) {
    function plus(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); var g = d.getDay(); if (g !== 0 && g !== 6) n--; } return d; }
    var f = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    var now = new Date();
    el.querySelector('[data-eta-min]').textContent = f.format(plus(now, 2));
    el.querySelector('[data-eta-max]').textContent = f.format(plus(now, 3));
    el.hidden = false;
  });

  /* Sticky add to cart on phones */
  var sticky = D.querySelector('[data-sticky-buy]');
  var mainBtn = D.querySelector('[data-buy] [type="submit"]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    var mq = window.matchMedia('(max-width: 899px)');
    new IntersectionObserver(function (es) {
      var e = es[0];
      var on = mq.matches && !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on);
      D.body.style.paddingBottom = on ? '76px' : '';
    }).observe(mainBtn);
    sticky.querySelector('button').addEventListener('click', function () { mainBtn.click(); });
  }

  /* Countdown to release */
  D.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = Date.parse(el.getAttribute('data-countdown'));
    if (isNaN(end)) return;
    var parts = {}; el.querySelectorAll('[data-cd]').forEach(function (b) { parts[b.getAttribute('data-cd')] = b; });
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; clearInterval(timer); return; }
      var s = Math.floor(ms / 1000);
      if (parts.d) parts.d.textContent = Math.floor(s / 86400);
      if (parts.h) parts.h.textContent = pad(Math.floor(s % 86400 / 3600));
      if (parts.m) parts.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (parts.s) parts.s.textContent = pad(s % 60);
      el.hidden = false;
    }
    var timer = setInterval(tick, 1000); tick();
  });

  /* Holo tilt on promo cards */
  if (!reduce) {
    D.querySelectorAll('[data-holo]').forEach(function (h) {
      var inner = h.querySelector('.holo-in'); if (!inner) return;
      h.addEventListener('pointermove', function (e) {
        var r = inner.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        h.classList.add('is-active');
        inner.style.setProperty('--ry', ((x - 0.5) * 18).toFixed(2) + 'deg');
        inner.style.setProperty('--rx', ((0.5 - y) * 18).toFixed(2) + 'deg');
        inner.style.setProperty('--sx', (100 - x * 100).toFixed(1) + '%');
      });
      h.addEventListener('pointerleave', function () {
        h.classList.remove('is-active');
        inner.style.setProperty('--rx', '0deg'); inner.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* In-stock filter */
  var inst = D.querySelector('[data-instock]');
  if (inst) {
    var count = D.querySelector('[data-count]'), none = D.querySelector('[data-none]');
    var cards = D.querySelectorAll('[data-card]');
    var apply = function () {
      var on = inst.checked, n = 0;
      cards.forEach(function (c) { var hide = on && c.getAttribute('data-available') === '0'; c.hidden = hide; if (!hide) n++; });
      if (count) count.textContent = on ? n + ' en stock sur ' + count.getAttribute('data-total') : count.getAttribute('data-total') + ' produit' + (Number(count.getAttribute('data-total')) > 1 ? 's' : '');
      if (none) none.hidden = !(on && n === 0);
      try { localStorage.setItem('ch-instock', on ? '1' : '0'); } catch (e) {}
    };
    try { if (localStorage.getItem('ch-instock') === '1') inst.checked = true; } catch (e) {}
    inst.addEventListener('change', apply);
    var off = D.querySelector('[data-instock-off]');
    if (off) off.addEventListener('click', function () { inst.checked = false; apply(); });
    apply();
  }

  /* Collection sorting */
  D.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });
})();
